import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_CARE_PLAN_DOCUMENTS_REQUEST: '',
  GET_CARE_PLAN_DOCUMENTS_SUCCESS: '',
  GET_CARE_PLAN_DOCUMENTS_FAILURE: '',

  GET_NEW_CARE_PLAN_ITEMS_COUNT_REQUEST: '',
  GET_NEW_CARE_PLAN_ITEMS_COUNT_SUCCESS: '',
  GET_NEW_CARE_PLAN_ITEMS_COUNT_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityCarePlan');

export default types;
